import { render, staticRenderFns } from "./soil-conventional-nutrients-echarts.vue?vue&type=template&id=61206ae6&scoped=true&"
import script from "./soil-conventional-nutrients-echarts.vue?vue&type=script&lang=js&"
export * from "./soil-conventional-nutrients-echarts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61206ae6",
  null
  
)

export default component.exports